import React from "react";

const { $ } = window;

interface Props {
    children: JSX.Element,
    onDrop: (event: DragEvent) => void,
}
interface State { }

class Droppable extends React.Component<Props, State> {
    readonly dragTargetId = "#dragtarget";
    readonly activeClassName = "droppable-active";
    readonly style = `
        .${this.activeClassName} {
            position: fixed;
            top: 0;
            left: 0;
            background: rgba(0, 0, 0, 0.5);
            width: 100%;
            height: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
            text-align: center;
            color: white;
            z-index: 999;
        }
    `;

    handleDragEnter = (event: DragEvent) => {
        event.preventDefault();
        event.stopPropagation();
        $(this.dragTargetId).removeClass("d-none").addClass(this.activeClassName);
    }

    handleDragOver = (event: DragEvent) => {
        event.preventDefault();
        event.stopPropagation();
    }

    handleDragLeave = (event: DragEvent) => {
        event.preventDefault();
        event.stopPropagation();
        $(this.dragTargetId).removeClass(this.activeClassName).addClass("d-none");
    }

    handleDrop = (event: DragEvent | any) => {
        this.props.onDrop(event);
        $(this.dragTargetId).removeClass(this.activeClassName).addClass("d-none");
    }

    componentDidMount(): void {
        $(window).on("dragenter", this.handleDragEnter);
        $(window).on("dragover", this.handleDragOver);
        $(window).on("mouseup", this.handleDragLeave);
        $(this.dragTargetId).on("dragleave", this.handleDragLeave);
        window.addEventListener("drop", this.handleDrop); // Can't use jquery for drop event for some reason
    }
    componentWillUnmount(): void {
        $(window).off("dragenter");
        $(window).off("dragover");
        $(window).off("mouseup");
        $(window).off("drop");
    }
    render() {
        const targetId = this.dragTargetId.substring(1);
        return (
            <>
                {this.props.children}
                <style>{this.style}</style>
                <div id={targetId} className="d-none fs-4 fw-bold">
                    Drop files here to send as attachments
                </div>
            </>
        );
    }
}

export default Droppable;
